import { getBootstrapIconUrlByKey } from '../Global/icons'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <wa-button size="small">
    <slot></slot>
    <slot name="buttonText"></slot>
  </wa-button>
`

class NavHeaderUtilityButton extends HTMLElement {
  private waButton!: HTMLElement | null
  private dynamicIcon: HTMLElement | null = null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button, WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    this.waButton = null
  }

  static get observedAttributes() {
    return ['variant', 'icon', 'href']
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === 'variant' && oldValue !== newValue) {
      this.applyVariant()
    }
    if (name === 'icon') {
      this.updateIcon()
    }
    if (name === 'href' && oldValue !== newValue) {
      this.applyHref()
    }
  }

  connectedCallback() {
    console.log('NavHeaderUtilityButton connectedCallback', this)

    this.waButton = this.shadowRoot!.querySelector('wa-button')

    this.applyVariant()
    this.updateIcon()
    this.applyHref()

    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
  }

  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
  }

  /* Applies CSS classes to the wrapped button based on the variant attribute (icon or text) */
  private applyVariant() {
    if (!this.waButton) return

    const variant = this.getAttribute('variant')

    this.waButton.classList.remove('utility-icon-button', 'utility-button')

    if (variant === 'icon') {
      this.waButton.classList.add('utility-icon-button')
    } else {
      // default behaviour (text button)
      this.waButton.classList.add('utility-button')
    }
  }

  private updateIcon() {
    if (!this.waButton) return

    const iconName = this.getAttribute('icon')

    // Remove existing dynamic icon
    if (this.dynamicIcon) {
      this.dynamicIcon.remove()
      this.dynamicIcon = null
    }

    if (!iconName) return

    const svgUrl = getBootstrapIconUrlByKey(iconName)

    if (!svgUrl) {
      console.warn(`Icon '${iconName}' not found`)
      return
    }

    const iconEl = document.createElement('wa-icon')
    iconEl.setAttribute('src', svgUrl)
    iconEl.classList.add('utility-icon')

    const isIconOnly = this.getAttribute('variant') === 'icon'

    if (!isIconOnly) {
      iconEl.setAttribute('slot', 'start')
    }

    this.waButton.appendChild(iconEl)
    this.dynamicIcon = iconEl
  }

  private applyHref() {
    if (!this.waButton) return

    const href = this.getAttribute('href')

    if (!href) {
      this.waButton.removeAttribute('href')
      return
    }
    this.waButton.setAttribute('href', href)
  }

  /* Handles search state changes by toggling the search-visible attribute */
  private handleSearchStateChange = (event: CustomEvent) => {
    const visible = event.detail?.visible

    if (visible === true) {
      this.setAttribute('search-visible', 'true')
    } else if (visible === false) {
      this.removeAttribute('search-visible')
    }
  }
}

if (!customElements.get('ts-navheader-utility-button')) {
  customElements.define('ts-navheader-utility-button', NavHeaderUtilityButton)
}
export { NavHeaderUtilityButton }
